// The order the API numbers a metric group by: order, then id for metrics that share an order.
export const compareMetricOrder = (a, b) => (a.order - b.order) || (a.id - b.id)
